export default {
  ajaxCallsInProgress: 0,
};
